import React from 'react';
import { Global } from '@emotion/core';
import { Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Portal from '@shared/v2/components/Portal';

import Body from './components/Body';
import Header from './components/Header';
import FullPageModalContext from './FullPageModalContext';

/**
 * @param {{ children: React.ReactNode }} props
 */
const FullPageModal = ({
  onClose,
  children,
  backgroundColor = 'rgba(0,0,0,0.8)',
}) => (
  <FullPageModalContext.Provider value={{ onClose }}>
    <Global
      styles={{
        body: {
          overflow: 'hidden',
        },
      }}
    />
    <Portal selector="portal-root">
      <Flex
        flexDirection="column"
        zIndex="popup"
        position="fixed"
        top="0"
        right="0"
        bottom="0"
        left="0"
        backgroundColor={backgroundColor}
      >
        {children}
      </Flex>
    </Portal>
  </FullPageModalContext.Provider>
);

FullPageModal.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
};

FullPageModal.Header = Header;
FullPageModal.Body = Body;

export default FullPageModal;
